function at<T>(this: Array<T>, n: number) {
    // ToInteger() abstract op
    n = Math.trunc(n) || 0;
    // Allow negative indexing from the end
    if (n < 0) n += this.length;
    // OOB access is guaranteed to return undefined
    if (n < 0 || n >= this.length) return undefined;
    // Otherwise, this is just normal property access
    return this[n];
}
// @ts-expect-error: Suppressed automatically in TS 5.8 to 6 migration
if (typeof Array.prototype.at !== "function") {
    Object.defineProperty(Array.prototype, "at", { value: at, writable: true, enumerable: false, configurable: true });
}
// @ts-expect-error: Suppressed automatically in TS 5.8 to 6 migration
if (typeof String.prototype.at !== "function") {
    Object.defineProperty(String.prototype, "at", { value: at, writable: true, enumerable: false, configurable: true });
}
